<template>
    <v-card text color="kbWhite">
        <v-card-text style="box-sizing: border-box">
            <v-row>
                <v-col class="pa-4" cols="12" v-if="creditCards.length > 0" >
                    <v-row dense>
                        <v-col md="12" lg="6" xl="4" v-for="(creditCard, index) in creditCards" :key="index" class="my-1">
                            <v-card elevation="3" text color="kbLight" style="border-radius: 10px">
                                <v-card-text style="box-sizing: border-box">
                                    <div style="display: flex; align-items: center; flex-wrap: wrap">
                                        <div class="xs12">
                                            <img :src="require(`@/assets/credit_cards_material_design/png/72/${getImageFileName(creditCard.brand)}.png`)"
                                                 height="72px">
                                        </div>

                                        <div class="xs12" style="padding: 10px">
                                            <div class="text-h5">
                                                {{ creditCard.brand }}
                                            </div>

                                            <div>
                                                {{$t('general.lastDigits')}}: {{ creditCard.last4Digits }}
                                            </div>

                                            <div>
                                                {{$t('general.cardExpirationDate')}}: {{ creditCard.expMonth }} / {{ creditCard.expYear }}
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-chip color="kbBlue"
                                            dark
                                            v-if="creditCard.main">
                                        Principal
                                    </v-chip>

                                    <span v-if="!creditCard.main">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="hidden-sm-and-up"
                                               @click="updateCreditCardSetMainCard(creditCard)"
                                               color="kbSemiLightGray"
                                               dark
                                               text
                                               icon
                                               v-on="on">
                                            <v-icon>
                                                mdi-credit-card-settings
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <span>{{$t('general.changeToPrincipal')}}</span>
                                </v-tooltip>

                                <v-btn rounded
                                       text
                                       class="hidden-xs-only"
                                       color="kbSemiLightGray"
                                       dark
                                       @click="updateCreditCardSetMainCard(creditCard)">
                                    {{$t('general.changeToPrincipal')}}
                                    <v-icon dark
                                            right>
                                        mdi-credit-card-settings
                                    </v-icon>
                                </v-btn>

                                <v-btn icon
                                       text
                                       color="error"
                                       @click="deleteCreditCard(creditCard)"
                                       :loading="deletingCard === creditCard.cardId">
                                    <v-icon dark>delete</v-icon>
                                </v-btn>
                            </span>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="text-center" @click="openAddCreditCardDialog()"
                       cols="12"
                       v-if="creditCards.length === 0">
                    <div class="add-credit-card-button"
                         v-ripple>
                        <v-icon color="kbDarkBlueText" size="60px">
                            mdi-credit-card-plus
                        </v-icon>
                        <br>
                        <span class="text-h6 kbDarkBlueText--text">{{$t('general.addCreditCard')}}</span>
                    </div>
                </v-col>
                <v-col class="text-right" cols="12" v-else>
                    <v-btn @click="openAddCreditCardDialog()"
                           color="kbBlue"
                           dark
                           rounded>
                        {{$t('general.addCreditCard')}}
                        <v-icon right dark>mdi-credit-card-plus</v-icon>
                    </v-btn>
                </v-col>
                <AddNewCreditCardDialog v-model="showNewCreditCardDialog" />
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapState } from 'vuex'
import bankBrandImages from '@/libs/bankBrandImages'
import notifications from '@/libs/notifications'
import AddNewCreditCardDialog from '@/pages/App/Settings/AddNewCreditCardDialog.vue'
export default {
  components: { AddNewCreditCardDialog },
  computed: {
    ...mapState({
      creditCards: state => state.payments.creditCards,
      selectedCompany: state => state.companies.selectedCompany
    })
  },
  data: () => ({
    deletingCard: '',
    getImageFileName: bankBrandImages.getImageFileName,
    showNewCreditCardDialog: false
  }),
  methods: {
    openAddCreditCardDialog () {
      if (!this.selectedCompany.email) {
        notifications.error(this.$t('general.completeBusinessDataBeforeAddingCreditCard'))
        return this.$router.push('/settings')
      }
      EventBus.$emit('openAddNewCreditCardDialog')
      this.showNewCreditCardDialog = true
    },
    async deleteCreditCard (card) {
      try {
        this.deletingCard = card.cardId
        await this.$store.dispatch('deleteCard', card.cardId)
        notifications.success(this.$t('general.creditCardSuccessfullyDeleted'))
        this.deletingCard = ''
      } catch (e) {
        notifications.error(this.$t('general.errorDeletingCreditCard'))
        this.deletingCard = ''
      }
    },
    async updateCreditCardSetMainCard (card) {
      try {
        this.updatingCardPriority = card.cardId
        await this.$store.dispatch('changeCardPriorityToMain', card.cardId)
        this.updatingCardPriority = ''
        notifications.success(this.$t('general.creditCardPriorityUpdated'))
      } catch (e) {
        this.updatingCardPriority = ''
        console.error(e)
      }
    }
  }
}
</script>

<style>
    .add-credit-card-button {
        cursor: pointer;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding: 10px 0;
    }
</style>
